// BD-1016: dashboard-wide "exclude disabled users" toggle. Off by default; NBD-25
// restores it per tenancy from sessionStorage for the rest of the session. Module-level
// rather than React context because index.js issues its hydration queries above
// any provider it could render. useDashboardData folds it into every request as
// scope.excludeDisabled; the server drops Enabled = false users from each widget.
import { createContext, useContext, useSyncExternalStore } from 'react';

let excludeDisabled = false;
const listeners = new Set();

export function getExcludeDisabled() {
    return excludeDisabled;
}

export function setExcludeDisabled(value) {
    const next = Boolean(value);
    if (next === excludeDisabled) return;
    excludeDisabled = next;
    listeners.forEach((fn) => fn());
}

function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

// BD-1245: risk figures are a benchmark, not a search, so the Risk page renders under
// this and hides the chip. useExcludeDisabled reads false there, so a toggle switched
// on from another page can't silently filter it.
export const IgnoreExcludeDisabled = createContext(false);

export function useExcludeDisabled() {
    const ignored = useContext(IgnoreExcludeDisabled);
    const on = useSyncExternalStore(subscribe, getExcludeDisabled);
    return on && !ignored;
}
